import React from 'react';
import { graphql, HeadProps, PageProps } from 'gatsby';
import { Kfh_AreaType } from '../../types/graphqlTypes';
import LocationSoldData from '../../components/locations/LocationSoldData';
import { SEO } from '../../components/Seo';

interface AreaPageProps {
  area: Kfh_AreaType;
}
const AreaSoldDataPage = ({ data }: PageProps<AreaPageProps>) => <LocationSoldData location={data.area} />;

export default AreaSoldDataPage;

export const Head = ({ data }: HeadProps<AreaPageProps>) => {
  const seo = data.area.seoPages.find((seoPage) => seoPage.remoteTypeName === 'KfhSeoAreaGuideSoldType');
  return <SEO data={seo} />;
};

export const pageQuery = graphql`
  query AreaSoldDataPageQuery($id: String!) {
    area: kfhAreaType(id: { eq: $id }) {
      id
      name
      relativeUrl
      artirixMultiSearch
      artirixDisplayName
      locationSoldDataChange {
        soldDataChanges {
          averages {
            year
            priceChange
            percentageChange
            direction
            average
          }
        }
      }
      locationSoldData {
        soldData {
          yearlyAverage {
            flatAverage
            average
            houseAverage
            year
          }
          monthlyStatistics {
            average
            detachedAverage
            flatAverage
            flatSold
            houseAverage
            houseSold
            period
            semiDetachedAverage
            summary
            terraceAverage
          }
          summary
          summary2
          lastYearMonthlyStatistics {
            averageMeanPrice
            flatMeanPrice
            houseMeanPrice
            monthYear
          }
        }
      }
      region {
        name
        locationSoldDataChange {
          soldDataChanges {
            averages {
              year
              priceChange
              percentageChange
              direction
              average
            }
          }
        }
        relatedAreas {
          edges {
            node {
              id
              name
              relativeUrl
              locationSoldDataChange {
                soldDataChanges {
                  averages {
                    year
                    priceChange
                    percentageChange
                    direction
                    average
                  }
                }
              }
            }
          }
        }
      }
      seoPages {
        remoteTypeName
        ... on KFH_KfhSeoAreaGuideSoldType {
          id
          h1
          htmlDescription
          metaAuthor
          metaCopyright
          noFollow
          metaKeywords
          metaDescription
          noIndex
          onSiteMap
          priority
          remoteTypeName
          slug
          title
        }
      }
    }
  }
`;
